// extracted by mini-css-extract-plugin
export default {"category":"category_category__v4eya"};